import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  mobileBreakpoint: number = 1024;
  isMobile: boolean = window.innerWidth < this.mobileBreakpoint;

  constructor(private router: Router) {}

  navigateToHowItWorks() {
    this.router.navigate(['/']).then(() => {
      setTimeout(() => {
        const element = document.querySelector('.how-it-works');
        if (element) element.scrollIntoView({behavior: 'smooth'});
      }, 200);
    })
  }

  navigateHome() {
    this.router.navigate(['/']);
  }
}
